import { useState } from "react";
import { useCollaboration } from "@/contexts/CollaborationContext";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Users, X } from "lucide-react";

export default function CollaborationBar() {
  const collab = useCollaboration();
  const [expanded, setExpanded] = useState(false);
  const [hidden, setHidden] = useState(false);

  if (hidden || !collab || !collab.activeUsers?.length) return null;

  if (!expanded) {
    return (
      <button
        onClick={() => setExpanded(true)}
        className="fixed bottom-4 right-4 z-40 w-9 h-9 rounded-full bg-[#0F0F0F] text-white shadow-lg border border-white/10 flex items-center justify-center hover:scale-105 transition-transform"
        title={`${collab.activeUsers.length} online`}
        data-testid="collaboration-bar-collapsed"
      >
        <Users className="w-3.5 h-3.5" />
        <span className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-[#2563EB] text-[9px] font-bold flex items-center justify-center">
          {collab.activeUsers.length}
        </span>
      </button>
    );
  }

  return (
    <div className="fixed bottom-4 right-4 z-40 max-w-[calc(100vw-32px)]" data-testid="collaboration-bar">
      <div className="bg-[#0F0F0F] text-white rounded-xl pl-4 pr-2 py-2 flex items-center gap-3 shadow-lg border border-white/10 max-w-full">
        <div className="flex -space-x-2 shrink-0">
          {collab.activeUsers.slice(0, 5).map((u) => (
            <Avatar key={u.user_id} className="w-7 h-7 border-2 border-[#0F0F0F]" title={`${u.name} - ${u.page}`}>
              <AvatarImage src={u.picture} />
              <AvatarFallback className="bg-[#2563EB] text-[10px] font-bold text-white">
                {u.name?.[0] || "?"}
              </AvatarFallback>
            </Avatar>
          ))}
        </div>
        <span className="text-xs text-white/60 shrink-0">
          {collab.activeUsers.length} online
        </span>
        {collab.recentChanges?.[0] && (
          <span className="text-[10px] text-white/40 max-w-[180px] truncate border-l border-white/10 pl-3 hidden sm:inline">
            {collab.recentChanges[0].action}: {collab.recentChanges[0].details?.substring(0, 30)}
          </span>
        )}
        <button
          onClick={() => setExpanded(false)}
          className="p-1 rounded hover:bg-white/10 shrink-0"
          title="Minimieren"
          data-testid="collaboration-bar-minimize"
        >
          <X className="w-3.5 h-3.5 text-white/60" />
        </button>
      </div>
    </div>
  );
}
